import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { SharedLanguage } from "@/components/shared";
import { AdminBalanceCard } from "../balance-card";

import { SvgAttribute } from "@/shared/constants/constants";
import { RoutesName } from "@/shared/constants/enums";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedLanguage,
    AdminBalanceCard,
  },
  data() {
    return {
      isLoading: false,
      authRepository: this.$projectServices.authRepository,
    };
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },

    displayedEmail(): string {
      return this.$projectServices.userRepo.userInfo.email;
    },

    isLogoutDisabled(): boolean {
      return this.isLoading;
    },

    inUserId(): number {
      const hostname = window.location.hostname;
      if (
        hostname.includes("uat.mex.broker") ||
        hostname.includes("localhost")
      ) {
        return 203; // UAT
      }
      return 204; // PROD
    },

    outUserId(): number {
      const hostname = window.location.hostname;
      if (
        hostname.includes("uat.mex.broker") ||
        hostname.includes("localhost")
      ) {
        return 204; // UAT
      }
      return 205; // PROD
    },
  },
  methods: {
    async handleLogout(): Promise<void> {
      this.isLoading = true;
      try {
        await this.authRepository.logout();
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
        this.$router.push({ name: RoutesName.login });
      }
    },
  },
});
